export function setGraphInQuery(graphUrl) {
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('graph', graphUrl);
    window.history.pushState({}, null, currentUrl.href);
}
export function clearGraphFromQuery() {
    var currentUrl = new URL(window.location.href);
    if (!currentUrl.searchParams.has('graph'))
        return;
    currentUrl.searchParams.delete('graph');
    window.history.pushState({}, null, currentUrl.href);
}
export function getGraphInQuery() {
    var currentUrl = new URL(window.location.href);
    return currentUrl.searchParams.get('graph');
}
